export default Object.freeze({
  Field: 1,
  ProcessName: 2,
  ProcessGroupName: 3,
  InstanceName: 4,
  InstanceCreated: 5,
  InstanceStatus: 6,
  ApplicantFullName: 7,
  ApprovedDate: 8,
  RejectedDate: 9,
  ApplicantNames: 10,
  ApplicantLastNames: 11,
  ApplicantEmail: 12,
  ApplicantPosition: 13,
  InstanceIdentifier: 14,
  Variable: 15,
  InstanceCommentsCount: 16,
  ApplicantArea: 17,
  EntityField: 18,
  EntityItemIdentifier: 19,
  EntityItemCreated: 20,
  EntityItemIsActive: 21,
  EntityItemUserCreator: 22,
  EntityItemUserModifier: 23,
  InstanceGoToAction: 25,
  InstancePercentCompleted: 26,
});
